<template>
<div class="chart-box">
	<el-row :gutter="20" style="margin: 30px 0;">
	  <el-col :span="6">
			<centerLeft defultIndex=" "/>
	  </el-col>
	  <el-col :span="18">
		  <el-card class="box-card" shadow="never">
		    <el-row :gutter="10">
		      <el-col :span="10">
				<el-card class="box-card" shadow="never">
				  <div slot="header" class="clearfix">
					<span>我的成果</span>
				  </div>
				  <el-row :gutter="5" style="text-align: center;">
					  <el-col :span="8">
						  <div class="grid-content bg-purple">
							  <p>{{resulDetail.resultNum}}</p>
							  <p>成果数</p>
						  </div>
					  </el-col>
					  <el-col :span="8">
						  <div class="grid-content bg-purple">
							  <p>{{resulDetail.scanNum}}</p>
							  <p>浏览量</p>
						  </div>
					  </el-col>
					  <el-col :span="8">
						  <div class="grid-content bg-purple">
							  <p>{{resulDetail.downloadNum}}</p>
							  <p>下载量</p>
						  </div>
					  </el-col>
				  </el-row>
				</el-card>
				<el-card class="box-card" shadow="never" style="margin-top: 15px;">
				  <div slot="header" class="clearfix">
					<span>成果详情</span>
				  </div>
				  <el-row :gutter="5" style="font-size: 14px;line-height: 22px;">
					  <el-col :span="12" style="color: #F3A000;">
						  <span>外文论文</span>
						  <span>{{resulDetail.wwlwNum}}</span>
					  </el-col>
					  <el-col :span="12" style="color: #2eb4eb;">
						  <span>中文论文</span>
						  <span>{{resulDetail.qklwNum}}</span>
					  </el-col>
					  <el-col :span="12" style="color: #3fbfbe;">
						  <span>图书专著</span>
						  <span>{{resulDetail.tszzNum}}</span>
					  </el-col>
					  <el-col :span="12" style="color: #fa4344;">
						  <span>专利成果</span>
						  <span>{{resulDetail.zlcgNum}}</span>
					  </el-col>
					  <el-col :span="12" style="color: #fa4344;">
						  <span>科研课题</span>
						  <span>{{resulDetail.kyktNum}}</span>
					  </el-col>
					  <el-col :span="12" style="color: #fa4344;">
						  <span>其他成果</span>
						  <span>{{resulDetail.qtcgNum}}</span>
					  </el-col>
				  </el-row>
				</el-card>
		      </el-col>
		      <el-col :span="14">
		    	  <el-card class="box-card" shadow="never">
		    	    <div slot="header" class="clearfix">
		    	  	<span>待认领 ({{claimCount}})</span>
		    	  	<router-link to="/center/claim" style="float: right;" type="text">更多</router-link>
		    	    </div>
		    	    <div v-for="item in claimList" 
					:key="item.baseId" 
					class="text item"
					>
		    	  	   <span @click="toDetail(item.baseId)">{{item.title}}</span>
					   <el-button @click="toUpdateDiss(item.baseType,item.baseId)" class="claim-btn" size="small">认领</el-button>
		    	    </div>
		    	  </el-card>
		      </el-col>
		    </el-row>
			<el-card class="box-card" shadow="never" style="margin-top: 10px;">
				<el-form ref="form" :model="searchForm" label-width="80px" size="medium">
					<div class="el-form-item">
					  <el-input placeholder="请输入内容" size="medium" v-model="searchForm.search" class="input-with-select">
					    <el-select v-model="searchForm.state" class="first-select" slot="prepend" placeholder="请选择">
					      <el-option
					        v-for="item in typeOptions"
					        :key="item.value"
					        :label="item.label"
					        :value="item.value">
					      </el-option>
					    </el-select>
					    <el-select v-model="searchForm.searchType" class="second-select" slot="prepend" placeholder="请选择">
					      <el-option
					        v-for="item in titleOptions"
					        :key="item.value"
					        :label="item.label"
					        :value="item.value">
					      </el-option>
					    </el-select>
					  </el-input>
					</div>
					<el-row>
					  <el-col :span="18">
					    <el-form-item label="发表时间">
					      <el-date-picker
					        v-model="val"
					        type="daterange"
					        range-separator="至"
					        start-placeholder="开始日期"
					        end-placeholder="结束日期" @change="changData">
					      </el-date-picker >
					    </el-form-item>
					  </el-col>
					  <el-col :span="6">
					    <el-button type="primary" size="medium" @click="searchData" plain icon="el-icon-search">检索</el-button>
					  </el-col>
					</el-row>
				</el-form>
				<el-checkbox v-model="checked">是否含全文</el-checkbox>
			</el-card>
			 <el-row class="type-opr">
			  <el-col :span="24" style="text-align: right">
			    <span >排序方式：</span>
			    <el-button-group>
			      <el-button 
						:type="searchForm.sortType==='XZL'?'success':'primary'"
						@click="changeSort('XZL')"
						 size="medium" plain>下载量<i class="el-icon-bottom el-icon--right"></i></el-button>
			      <el-button
						 :type="searchForm.sortType==='LLS'?'success':'primary'"
						 @click="changeSort('LLS')"
						 size="medium" plain>浏览数<i class="el-icon-bottom el-icon--right"></i></el-button>
			    </el-button-group>
			  </el-col>
			</el-row>
			<el-card class="box-card" shadow="never">
				<el-table
				  :data="tableData"
				  style="width: 100%">
				  <el-table-column label="名称" min-width="300px">
					<template slot-scope="scope">
					   <span @click="toDetail(scope.row.baseId)" size="small">{{scope.row.title}}</span> 
					</template>
				  </el-table-column>
				  <el-table-column
					prop="showPublish"
					label="创建时间"
					width="180">
				  </el-table-column>
				  <el-table-column
					prop="state"
					label="状态" :formatter="formatState">
				  </el-table-column>
				  <el-table-column label="操作" align="center">
					<template slot-scope="scope">
					   <el-button v-if="scope.row.state===0" @click="toUpdateDiss(scope.row.baseType,scope.row.baseId,scope.row.vipFlag)" size="small">认领</el-button>
					   <el-button v-else-if="scope.row.state===1" @click="toUpdateDiss(scope.row)" size="small">编辑</el-button>
					   <el-button v-else-if="scope.row.state===10" @click="handleClaim(scope.row)" size="small">再次申请报销</el-button>
					   <el-button v-else-if="scope.row.state===4" @click="handleClaim(scope.row)" size="small">再次申请报销</el-button>
					   <el-button v-else @click="toDetail(scope.row.baseId)" size="small">查看</el-button>
					</template>
				 </el-table-column>
				</el-table>
				<el-pagination
				  background
				  layout="prev, pager, next"
				  :total="total" :current-page="currentPage" :page-size="pageSizes" @current-change="currentChange" style="text-align: right">
				</el-pagination>
			</el-card>	
		  </el-card>	  
	  </el-col>
	</el-row>
</div>
</template>

<script>
	import axios from 'axios';
	import centerLeft from '../../components/center-left.vue'
	export default {
	  name: "left",
		components:{
			centerLeft
		},
		data(){
		    return{
		        activeName: 'second',
				isRouter:true,
				total:0,
				currentPage:1,
				pageSizes:5,
				typeOptions: [{
						value: '0',
						label: '待认领'
					},
					{
						value: '1',
						label: '待提交'
					},
					{
						value: '2',
						label: '待审核'
					},
					{
						value: '3',
						label: '审核中'
					},
					{
						value: '4',
						label: '不通过'
					},
					{
						value: '5',
						label: '已审核'
					},
					{
						value: '6',
						label: '不审核'
					},
					{
						value: '7',
						label: '等待报销'
					},
					{
						value: '8',
						label: '正在报销'
					},
					{
						value: '9',
						label: '报销成功'
					},
					{
						value: '10',
						label: '报销失败'
				}],
				titleOptions: [
					{
						value: 'title',
						label: '标题'
					},
					// {
					// 	value: 'author',
					// 	label: '作者'
					// },
					{
						value: 'journal_name',
						label: '来源'
					}],
				searchForm:{
					beginTime:"",
					endTime:"",
					searchType:"",
					state:"",
					search:"",
					sortType:"XZL",
					pageNo:1
				},
		        checked:false,
				tableData: [],
				userId:"" ,
				claimList:[],
				claimCount:0,
				resulDetail:{
					fullNum: 0,
					downloadNum:0,
					scanNum:0
				},
				val:""
		    }
		},
		 methods:{
			currentChange(val){
				this.searchForm.pageNo=val;
				this.searchData()
			},
			changData(data){
				this.searchForm.beginTime=data[0].getFullYear() + '-' + (data[0].getMonth() + 1) + '-' + data[0].getDate();
				this.searchForm.endTime=data[1].getFullYear() + '-' + (data[1].getMonth() + 1) + '-' + data[1].getDate();
			},
			changeSort(val){
				this.searchForm.sortType=val;
				this.searchData();
			},
			formatState(row){
				if(row.state === 0){
					return "待认领"
				}
				else if(row.state === 1){
					return "待提交"
				}
				else if(row.state === 2){
					return "待审核"
				}
				else if(row.state === 3){
					return "审核中"
				}
				else if(row.state === 4){
					return "不通过"
				}
				else if(row.state === 5){
					return "已审核"
				}
				else if(row.state === 6){
					return "不审核"
				}
				else if(row.state === 7){
					return "等待报销"
				}
				else if(row.state === 8){
					return "正在报销"
				}
				else if(row.state === 9){
					return "报销成功"
				}
				else if(row.state === 10){
					return "报销失败"
				}
				else{
					return "其他"
				}
			},
			getClaim(id){
				let currThis=this;
				//待认领列表
				axios({
					method: 'get',
					url: '/api/member/memberClaim/'+id ,
				}).then(function (response) {
					//console.log(response);
					currThis.claimList = response.data.data.resultList;
					currThis.claimCount = response.data.data.totalCount;
				}).catch(function (thrown) {
					console.log(thrown)
				});
			},
			getResult(id){
				let currThis=this;
				//我的成果
				/* axios({
					method: 'get',
					url: '/api/member/memberStatic/'+id ,
				}).then(function (response) {
					console.log(response);
					currThis.resulDetail=response.data.data;
				}).catch(function (thrown) {
					console.log(thrown)
				}); */
				axios({
					method: 'get',
					url: '/api/memberIndex/'+id ,
				}).then(function (response) {
					console.log(response);
					currThis.resulDetail=response.data.data;
				}).catch(function (thrown) {
					console.log(thrown)
				});
			},
			searchData(){
				let currThis=this;
				let data=this.searchForm;
				axios({
					method: 'get',
					url: '/api/member/queryIndexData?pageNo='+data.pageNo+ "&claimUserId=" + this.userId + "&search=" + data.search + "&beginTime=" + data.beginTime + "&endTime=" + data.endTime + "&searchType=" + data.searchType + "&state=" + data.state,
				}).then(function (response) {
					//console.log(response);
					currThis.total= response.data.pageTotal;
					currThis.tableData = response.data.list;
				}).catch(function (thrown) {
					console.log(thrown)
				});
			},
			handleView(row){
				console.log(row);
			},
			toUpdateDiss(val1,val2,val3){
				 if (val1 == 'irBooks') {
					//window.location.href = "/front/member/books/initAdd/21/" + val2;
				} else if (val1 == 'irScientifictask') {
					//window.location.href = "/front/member/scientifictask/initAdd/21/" + val2;
				} else if (val1 == 'irDegreeDiss') {
					//window.location.href = "/front/member/degree/initAdd/21/" + val2;
				} else if (val1 == 'irForeginDiss') {
					this.$router.push({
					　　path: '/center/foreign',query: {id: val2}
					});
				} else if (val1 == 'irJournalDiss') {
					this.$router.push({
					　　path: '/center/china',query: {id: val2}
					}); 
				} else if (val1 == 'irMeetingDiss') {
					//window.location.href = "/front/member/meeting/initAdd/21/" + val2;
				} else if (val1 == 'irPatent') {
					//window.location.href = "/front/member/patent/initAdd/21/" + val2;
				} else {
					//window.location.href = "/front/member/others/initAdd/21/" + val2;
				}
			},
			toDetail(id){
				this.$router.push({
				　　path: '/center/view',query: {id: id}
				});
			}
		},
		mounted() {
			//this.userId=localStorage.getItem('userId');
			this.userId=this.$cookies.get('rtnVal') ;
			this.getClaim(this.userId);
			this.getResult(this.userId);
			this.searchData();
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/center/index.vue